module.exports = __webpack_public_path__ + "img/slider-33.27df2cd9.jpg";